import React from 'react'
import classNames from 'classnames'

import { LntTabs } from '@app/components/base'

import styles from './styles.module.scss'

import type { ActivityFeedProps } from './types'

export const ActivityFeed: React.FC<ActivityFeedProps> = props => {
  const { tabsItems, className: outerClassName, defaultActiveKey } = props

  const className: string = classNames(outerClassName, styles.activityFeedLayout)

  return (
    <div className={ className }>
      <h5 className={ styles.activityFeed__title }>Лента активности</h5>
      <LntTabs
        defaultActiveKey={ defaultActiveKey }
        items={ tabsItems }
      />
    </div>
  )
}
